var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitedTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_6271_193103)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 7.66797C11.4024 7.66797 7.66406 11.4063 7.66406 16.0013C7.66406 20.5963 11.4024 24.3346 15.9974 24.3346C20.5924 24.3346 24.3307 20.5963 24.3307 16.0013C24.3307 11.4063 20.5924 7.66797 15.9974 7.66797ZM19.4099 19.538C18.7189 20.23 17.8397 20.7036 16.8816 20.8996C16.2178 21.0348 15.5336 21.0348 14.8699 20.8996C14.2293 20.7699 13.6208 20.5141 13.0799 20.1471C12.5479 19.7864 12.0895 19.3277 11.7291 18.7955L13.1107 17.8646C13.2299 18.0405 13.3666 18.2063 13.5174 18.3563C13.8212 18.6617 14.1815 18.9051 14.5782 19.073C14.7807 19.158 14.9907 19.2238 15.2024 19.2663C15.6469 19.3555 16.1046 19.3555 16.5491 19.2663C16.7599 19.223 16.9699 19.1571 17.1741 19.0721C17.3691 18.9888 17.5607 18.8855 17.7399 18.7655C17.9132 18.6471 18.0791 18.5105 18.2324 18.358C18.3849 18.2063 18.5216 18.0405 18.6399 17.8646L20.0216 18.7955C19.8424 19.0621 19.6366 19.3121 19.4099 19.538ZM21.8307 14.3346C21.8307 14.7767 21.6551 15.2006 21.3426 15.5131C21.03 15.8257 20.6061 16.0013 20.1641 16.0013H18.4974C18.0554 16.0013 17.6314 15.8257 17.3189 15.5131C17.0063 15.2006 16.8307 14.7767 16.8307 14.3346H15.1641C15.1641 14.7767 14.9885 15.2006 14.6759 15.5131C14.3633 15.8257 13.9394 16.0013 13.4974 16.0013H11.8307C11.3887 16.0013 10.9648 15.8257 10.6522 15.5131C10.3397 15.2006 10.1641 14.7767 10.1641 14.3346V12.668H21.8307V14.3346Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6271_193103",
    x1: -1.58138e-9,
    y1: 16,
    x2: 31.9457,
    y2: 15.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedTime);
export default __webpack_public_path__ + "static/media/limited-time.3b38f6794f0ceb42dc924ce1f96eb052.svg";
export { ForwardRef as ReactComponent };